module.exports = __webpack_public_path__ + "img/es.30380216.png";